import { render, staticRenderFns } from "./dashboard copy.vue?vue&type=template&id=178a62fd"
import script from "./dashboard copy.vue?vue&type=script&lang=js"
export * from "./dashboard copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports